module.exports = __webpack_public_path__ + "img/registration.1e25e8fc.png";